/* eslint-env browser */
import React from "react";
import PropTypes from "prop-types";
import { translate } from "react-i18next";

export class BaseFooterSocialLinks extends React.Component {
  static get NAME() {
    return "BaseFooterSocialLinks";
  }
  // constructor(props) {
  //   super(props);
  // }
  render() {
    return (
      <div style={this.props.style}>
        <div
          className={`social-footer-links inBusiness`}
          style={{
            float: "left",
            marginRight: "20px",
            transition: "color 300ms ease-out"
          }}
          onClick={e => {
            e.preventDefault();
            const url = "https://twitter.com/foodiestrip";
            window.open(url, "_blank");
          }}
        >
          <i
            style={{ fontSize: "20px", cursor: "pointer" }}
            className="fab fa-twitter"
          />
        </div>
        <div
          className={`social-footer-links inBusiness`}
          style={{
            float: "left",
            marginRight: "20px",
            transition: "color 300ms ease-out"
          }}
          onClick={e => {
            e.preventDefault();
            const url = "https://www.facebook.com/foodiestrip";
            window.open(url, "_blank");
          }}
        >
          <i
            style={{ fontSize: "20px", cursor: "pointer" }}
            className="fab fa-facebook"
          />
        </div>
        <div
          className={`social-footer-links inBusiness`}
          style={{
            float: "left",
            marginRight: "20px",
            transition: "color 300ms ease-out"
          }}
          onClick={e => {
            e.preventDefault();
            const url = "https://plus.google.com/+Foodiestrip";
            window.open(url, "_blank");
          }}
        >
          <i
            style={{ fontSize: "20px", cursor: "pointer" }}
            className="fab fa-google-plus"
          />
        </div>
        <div
          className={`social-footer-links inBusiness`}
          style={{
            float: "left",
            marginRight: "20px",
            transition: "color 300ms ease-out"
          }}
          onClick={e => {
            e.preventDefault();
            const url = "https://www.linkedin.com/company/foodiestrip.com/";
            window.open(url, "_blank");
          }}
        >
          <i
            style={{ fontSize: "20px", cursor: "pointer" }}
            className="fab fa-linkedin"
          />
        </div>
        <div
          className={`social-footer-links inBusiness`}
          style={{
            float: "left",
            marginRight: "20px",
            transition: "color 300ms ease-out"
          }}
          onClick={e => {
            e.preventDefault();
            const url = "https://www.instagram.com/foodiestrip_app/";
            window.open(url, "_blank");
          }}
        >
          <i
            style={{ fontSize: "20px", cursor: "pointer" }}
            className="fab fa-instagram"
          />
        </div>
        <div
          className={`social-footer-links inBusiness`}
          style={{ float: "left", transition: "color 300ms ease-out" }}
          onClick={e => {
            e.preventDefault();
            const url =
              "https://www.youtube.com/channel/UCWip3dcX54UlqebjSJeJnEA";
            window.open(url, "_blank");
          }}
        >
          <i
            style={{ fontSize: "20px", cursor: "pointer" }}
            className="fab fa-youtube"
          />
        </div>
      </div>
    );
  }
}

BaseFooterSocialLinks.propTypes = {
  language: PropTypes.string.isRequired,
  style: PropTypes.object
};
BaseFooterSocialLinks.defaultProps = {
  style: {
    display: "inline-block",
    width: "100%",
    marginTop: "-7px",
    paddingLeft: "5px",
    maxWidth: "130px"
  }
};

const FooterSocialLinks = translate()(BaseFooterSocialLinks);
export default FooterSocialLinks;



// WEBPACK FOOTER //
// ./src/components/Footer/FooterSocialLinks.jsx